<template src="./DocumentManager.html"></template>

<script>
import Companies from "../../../components/Forms/Companies/Companies";
import {
  getDocuments,
  getCompliance,
  getUserComplianceCompanies,
  deleteDocument,
} from "../../../services";
import { mapGetters } from "vuex";
import moment from "moment";
import {
  OnlyAdmin,
  AdminCompliance,
  NotClientCompliance,
  OnlyClientCompliance,
  adminAndRiskAdmin,
} from "../../../utils/roles";
import { ROL } from "../../../services/roles";

const DOCUMENT_STATUS = {
  ABOUT_TO_EXPIRE: "ABOUT_TO_EXPIRE",
  UPDATED: "UPDATED",
};

export default {
  name: "DocumentManager",
  components: { Companies },
  data() {
    return {
      search: {
        name: "",
        endDate: null,
        starDate: null,
        companyId: null,
        userId: null,
        status: DOCUMENT_STATUS.ABOUT_TO_EXPIRE,
      },
      loading: false,
      documents: [],
      headers: [
        { text: "Nombre documento", value: "name" },
        { text: "Cliente", value: "company" },
        { text: "Usuario", value: "responsibleUser" },
        { text: "Fecha de Vencimiento", value: "plannedDate" },
        { text: "Estado", value: "status" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      filterStatus: null,
      filterStatusOptions: [
        { text: "Próximo a vencer", value: "ABOUT_TO_EXPIRE" },
        { text: "Actualizado", value: "UPDATED" },
      ],
      totalDocuments: 0,
      // startDateMenu: false,
      endDateMenu: false,
      usersCompliance: [],
      disabled: false,
      skip: 0,
      take: 100,
      DOCUMENT_STATUS: DOCUMENT_STATUS,
      companies: [],
    };
  },
  computed: {
    filteredDocuments() {
      let filtered = this.documents;

      if (this.filterStatus) {
        filtered = filtered.filter(
          (doc) => this.formatStatus(doc.status) === this.filterStatus
        );
      }

      if (this.filterCreationDate) {
        filtered = filtered.filter((doc) => {
          const docCreationDate = doc.createdAt
            ? this.formatDate(doc.createdAt)
            : null;
          return docCreationDate === this.filterCreationDate;
        });
      }

      if (this.filterExpirationDate) {
        filtered = filtered.filter((doc) => {
          const docExpirationDate = doc.plannedDate
            ? this.formatDate(doc.plannedDate)
            : null;
          return docExpirationDate === this.filterExpirationDate;
        });
      }

      return filtered;
    },
    ...mapGetters({
      user: "getUser",
    }),
    isStatus() {
      return (status) => this.search.status !== status;
    },
    OnlyAdmin,
    AdminCompliance,
    NotClientCompliance,
    OnlyClientCompliance,
    adminAndRiskAdmin,
  },
  async created() {
    this.fetchDocuments();
    this.listUsersCompliance();
    this.listCompanies();
  },
  methods: {
    async fetchDocuments(addDocuments = false) {
      this.loading = true;
      try {
        if (
          this.OnlyAdmin(this.user.rol) ||
          this.adminAndRiskAdmin(this.user.rol) ||
          this.OnlyClientCompliance(this.user.rol)
        ) {
          // Admin roles keep whatever userId the filter has (null = all users)
        } else {
          this.search.userId = this.user.id;
        }

        if (this.OnlyClientCompliance(this.user.rol)) {
          this.search.companyId = this.user.company.id;
        }

        const filters = {
          ...this.search,
          skip: this.skip,
          take: this.take,
        };

        const response = await getDocuments(filters);

        const documentData = Array.isArray(response.data) ? response.data : [];

        if (!addDocuments) {
          this.documents = documentData;
        } else {
          this.documents.push(...documentData);
        }

        this.totalDocuments = response.total;

        if (documentData.length < this.take) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
      } finally {
        this.loading = false;
      }
    },

    async listUsersCompliance() {
      try {
        const userCompliance = await getCompliance();
        this.usersCompliance = userCompliance.map((user) => {
          user.fullname = `${user.name} ${user.lastName}`;
          return user;
        });
      } catch (err) {
        console.log("Error on list usersCompliance:", err);
      }
    },
    getTaskByStatus() {
      this.skip = 0;
      this.take = 100;
      this.disabled = false;
    },
    manualFilterCleaning() {
      this.search = {
        companyId: null,
        name: "",
        endDate: null,
        userId: null,
        status: this.search.status,
      };
      this.skip = 0;
      this.fetchDocuments();
    },
    formatDate(dateString) {
      if (!dateString) return "N/A";

      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "N/A";
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    formatStatus(status) {
      switch (status) {
        case "ABOUT_TO_EXPIRE":
          return "Próximo a vencer";
        case "UPDATED":
          return "Actualizado";
        default:
          return status;
      }
    },
    getStatusColor(status) {
      switch (status) {
        case "ABOUT_TO_EXPIRE":
          return "#fc5b00";
        case "UPDATED":
          return "green";
        default:
          return "grey";
      }
    },
    viewDocument(item) {
      const route = this.$router.resolve({
        name: "ViewDocumentDetails",
        params: { id: item.id },
      });
      window.open(route.href, "_blank");
    },
    editDocument(document) {
      const docKey = `reportDocument_${document.id}_${Date.now()}`;
      sessionStorage.setItem(docKey, JSON.stringify(document));
      const route = this.$router.resolve({
        name: "Reportar Documentos",
        query: { docKey },
      });
      window.open(route.href, "_blank");
    },
    manualSearchDocument() {
      this.skip = 0;
      this.fetchDocuments();
    },
    getDocumentsByStatus() {
      this.skip = 0;
      this.take = 100;
      this.disabled = false;
      this.fetchDocuments();
    },
    moreDocuments() {
      this.skip += this.take;
      this.fetchDocuments(true);
    },
    getAlertStatus(plannedDate) {
      if (!plannedDate) return null;

      const today = moment().startOf("day");
      const date = moment(plannedDate).startOf("day");
      const diffInDays = date.diff(today, "days");

      if (diffInDays <= 30) {
        return "red";
      } else if (diffInDays <= 60) {
        return "warning";
      } else if (diffInDays <= 90) {
        return "primary";
      }

      return null;
    },
    async listCompanies() {
      try {
        if (this.user.rol === ROL.COMPANY_COMPLIANCE) {
          this.companies = this.user.company;
        } else {
          this.companies = await getUserComplianceCompanies();
        }
      } catch (err) {
        console.error("Error al listar las empresas:", err);
      }
    },
    updateCompany(id) {
      this.search.companyId = id;
    },
    ifDeleteDocument(document) {
      this.$swal({
        title: '¿Está seguro de eliminar el documento?',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((value) => {
        if (value) {
          this.removeDocument(document);
        }
      });
    },
    async removeDocument(document) {
      try {
        await deleteDocument(document.id);
        this.$swal({
          text: 'Se eliminó el documento.',
          buttons: false,
          icon: 'success',
          timer: 3000,
        });
        this.documents = this.documents.filter((doc) => doc.id !== document.id);
      } catch (err) {
        console.error('Error on remove document', err);
        this.$swal({
          text: err.message || 'Ocurrió un error, intenta más tarde.',
          buttons: false,
          icon: 'error',
          timer: 3000,
        });
      }
    },
  },
};
</script>

<style lang="scss" src="./DocumentManager.scss" scoped></style>
